import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Package, ShoppingBag, Users, LayoutDashboard, BarChart3, Store, ShoppingCart, Megaphone, FileArchive } from 'lucide-react';
import { useNotifications } from '../../contexts/NotificationContext';
import AdminOrders from './AdminOrders';
import AdminProducts from './AdminProducts';
import AdminCustomers from './AdminCustomers';
import AdminStats from './AdminStats';
import AdminResellerShops from './AdminResellerShops';
import AdminB2COrders from './AdminB2COrders';
import AdminBanners from './AdminBanners';
import AdminBulkImageUpload from './AdminBulkImageUpload';

function AdminDashboard() {
  const [searchParams] = useSearchParams();
  const { pendingShopCount } = useNotifications();
  const [activeTab, setActiveTab] = useState(searchParams.get('tab') || 'stats');

  useEffect(() => {
    const tab = searchParams.get('tab');
    if (tab) setActiveTab(tab);
  }, [searchParams]);

  const tabs = [
    { id: 'stats', label: 'Statistiken', icon: BarChart3 },
    { id: 'orders', label: 'B2B-Bestellungen', icon: Package },
    { id: 'b2c-orders', label: 'B2C-Bestellungen', icon: ShoppingCart },
    { id: 'products', label: 'Produkte', icon: ShoppingBag },
    { id: 'customers', label: 'Kunden', icon: Users },
    { id: 'reseller-shops', label: 'Reseller-Shops', icon: Store },
    { id: 'banners', label: 'Banner', icon: Megaphone },
    { id: 'bulk-images', label: 'Bilder-Bulk-Upload', icon: FileArchive }
  ];

  return (
    <div className="container mx-auto px-4 lg:px-12 py-8">
      {/* Header */}
      <div className="flex items-center gap-3 mb-8">
        <LayoutDashboard className="h-8 w-8" />
        <h1 className="text-3xl md:text-4xl font-heading font-bold uppercase" data-testid="admin-title">
          Admin Dashboard
        </h1>
      </div>

      {/* Navigation Tabs */}
      <div className="flex flex-wrap gap-2 mb-8 border-b border-gray-200 pb-4">
        {tabs.map(tab => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`flex items-center gap-2 px-4 py-2 rounded-md transition-colors ${
                activeTab === tab.id 
                  ? 'bg-primary text-primary-foreground' 
                  : 'bg-gray-100 hover:bg-gray-200 text-gray-700'
              }`}
              data-testid={`admin-tab-${tab.id}`}
            >
              <Icon className="h-4 w-4" />
              {tab.label}
              {tab.id === 'reseller-shops' && pendingShopCount > 0 && (
                <span className="bg-red-500 text-white text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center animate-pulse" data-testid="pending-shops-tab-badge">
                  {pendingShopCount}
                </span>
              )}
            </button>
          );
        })}
      </div>

      {/* Content */}
      <div>
        {activeTab === 'stats' && <AdminStats />}
        {activeTab === 'orders' && <AdminOrders />}
        {activeTab === 'b2c-orders' && <AdminB2COrders />}
        {activeTab === 'products' && <AdminProducts />}
        {activeTab === 'customers' && <AdminCustomers />}
        {activeTab === 'reseller-shops' && <AdminResellerShops />}
        {activeTab === 'banners' && <AdminBanners />}
        {activeTab === 'bulk-images' && <AdminBulkImageUpload />}
      </div>
    </div>
  );
}

export default AdminDashboard;
